import { Image } from '@chakra-ui/react';
import { useContext, useMemo } from 'react';

import { DigitalContentThumbnail } from '~/components/collection/DigitalContentThumbnail';
import { apiClient } from '~/lib/apiClient';
import { urlToExtension } from '~/lib/utils/url';
import { RootContext } from '~/store';
import type { GrantedBenefit } from '~/types/resources/grantedBenefit';

type Props = {
  grantedBenefit?: GrantedBenefit;
};

export const BenefitDigitalContentThumbnailContainer: React.FC<Props> = (
  props: Props
) => {
  const contentExtension = useMemo(() => {
    if (props.grantedBenefit == null) return null;
    if (props.grantedBenefit.benefit.digital_content_url == null) return null;
    return urlToExtension(props.grantedBenefit.benefit.digital_content_url);
  }, [props.grantedBenefit?.benefit.digital_content_url]);

  const { token } = useContext(RootContext);

  const resetDownloadUrl = async () => {
    if (props.grantedBenefit == null)
      throw new Error('予期せぬエラーが発生しました');
    const res = await apiClient.v1.me.granted_prizes.benefits
      ._benefitPrizeId(props.grantedBenefit.benefit.id)
      .download.$get({
        headers: {
          Authorization: `Bearer ${token?.token}`,
        },
      });

    return res.signed_url;
  };

  if (props.grantedBenefit == null) return null;
  if (contentExtension != 'image') {
    return (
      <Image
        src={props.grantedBenefit.benefit.image_url}
        alt={`${props.grantedBenefit.benefit.name}の画像`}
        loading="lazy"
        maxH="400px"
      />
    );
  }
  return <DigitalContentThumbnail onResetDownloadUrl={resetDownloadUrl} />;
};
